import React from "react";
import styles from "./styles.module.scss";
import Team from "../Team";
import useWindowWidth from "hooks/useWindowWidth";

const AboutHeader = ({ title, text, additionalText }) => {
  const width = useWindowWidth();
  return (
    <div className="container">
      <div className={styles.title}>
        <div className={styles.left}>
          {width > 767 && <h1>{title}</h1>}
          <p className="text_xl">{text}</p>
          <p className="text_xl">{additionalText}</p>
        </div>
        <div className={styles.right}>
          {width < 767 && <h1>{title}</h1>}
          <Team />
        </div>
      </div>
    </div>
  );
};

export default AboutHeader;
